import React from 'react';

const wrapperStyles = {
  position: 'fixed',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 20%',
};

const titleStyles = {
  textAlign: 'center',
};

const linkStyles = {
  marginTop: '2rem',
  color: 'inherit',
  textDecoration: 'none',
  padding: '1rem',
  border: '1px solid black',
};

const TOSRefusedPage = () => (
  <div style={wrapperStyles}>
    <h1 style={titleStyles}>You have to accept TOS in order to use this app</h1>
    <a href="/" style={linkStyles}>
      Return to TOS dialog
    </a>
  </div>
);

export default TOSRefusedPage;
